//@ constants
const actionTypes = require('../constants/actionTypes');

const saveIban = (iban) => ({
	type: actionTypes.OKIBAN_SET_IBAN,
	iban
});

const saveCCC = (data) => ({
	type: actionTypes.OKIBAN_SET_CCC,
	data
});

const verifing = () => ({
	type: actionTypes.OKIBAN_VERIFING
});

const error = (data) => ({
	type: actionTypes.OKIBAN_ERROR,
	data
});

const reset = () => ({
	type: actionTypes.OKIBAN_RESET
});

const internalReset = () => ({
	type: actionTypes.OKIBAN_INTERNAL_RESET
});

module.exports = {
	saveIban,
	saveCCC,
	verifing,
	error,
	reset,
	internalReset
}
